module.exports = __webpack_public_path__ + "static/img/图层 511.0754a094.png";